export default __webpack_public_path__ + "static/media/Ts.59362199.jpg";